export const showOrdersheetOutside = () => {
  return (
    (window.InterfaceElements.IsJpeg && window.flags.showOrdersheetOutsideInJpeg) ||
    window.flags.showOrdersheetOutside ||
    window.flags.homeTemplate == "CREATEYOURRUG"
  );
};
